import Immutable from 'immutable';
import moment from 'moment';

import { START_TAB_TRACKING, FINISH_TAB_TRACKING } from './actions';
import { trackAction } from '../../../native/bridge/SegmentAnalyticHelper';
import { NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS } from '../../../web/client-data/site-data';
import { selectCurrentUserEducatorSubscription } from '../../UserSubscriptionPlans/selectors';
import {
  NOTIFICATION_TAB,
  FEED_TAB,
  COURSE_TAB,
  MISC_TAB,
} from '../../../native/containers/AppTabs/constants';

export function setupTrackTabDetail(eventName, segmentDetails) {
  return (dispatch) => {
    dispatch({
      type: START_TAB_TRACKING,
      prevTabIndex: -1,
      currentTabIndex: -1,
      eventName,
      segmentDetails,
    });
  };
}

export function submitTrackAction(leaveAction) {
  return (dispatch, getState) => {
    if (getState().TabTracking.get('segmentDetails') !== Immutable.Map()) {
      const currentTime = moment();
      const eventName = getState().TabTracking.get('eventName', '');
      const activityStartTime = getState().TabTracking.getIn(
        ['segmentDetails', 'interaction.activityStartTime'],
        currentTime
      );

      const timeSpent = currentTime.diff(activityStartTime, 'seconds');

      let segmentDetails = getState().TabTracking.get('segmentDetails');
      segmentDetails = segmentDetails.merge(
        Immutable.fromJS({
          'interaction.timeSpent': timeSpent,
          'interaction.leaveAction': leaveAction,
        })
      );
      segmentDetails = segmentDetails.delete('interaction.activityStartTime');
      const userEducatorSubscriptionPlan = selectCurrentUserEducatorSubscription(
        getState()
      );
      let options = {};
      if (!userEducatorSubscriptionPlan) {
        options = {
          ...NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS,
        };
      }

      trackAction(eventName, segmentDetails.toJS(), {
        integrations: options,
      });
      dispatch({
        type: FINISH_TAB_TRACKING,
      });
    }
  };
}

export function trackTab(prevSelectedTabKey, currentSelectedTabKey) {
  return (dispatch, getState) => {
    // detect if prev in course activity, now switch to another tab, and segment details exist, trigger segment
    if (
      ((prevSelectedTabKey === FEED_TAB &&
        currentSelectedTabKey !== FEED_TAB) ||
        (prevSelectedTabKey === COURSE_TAB &&
          currentSelectedTabKey !== COURSE_TAB)) &&
      getState().TabTracking.get('segmentDetails') !== Immutable.Map()
    ) {
      let leaveAction = '';
      switch (currentSelectedTabKey) {
        case NOTIFICATION_TAB:
          leaveAction = 'notificationsTab';
          break;
        case FEED_TAB:
          leaveAction = 'feedsTab';
          break;
        case COURSE_TAB:
          leaveAction = 'progressTab';
          break;
        case MISC_TAB:
          leaveAction = 'profileTab';
          break;
        default:
          leaveAction = '';
          break;
      }
      dispatch(submitTrackAction(leaveAction));
    }
  };
}
